export default {
    updated: function(el, binding, vnode) {

        // console.log('aquiiii',binding.value.exerciseAnswers)
        if(binding.value.grade === null) {
            console.log('entrouuu');
            console.log(binding.value.grade);
            
            return
            
        }
        
        if(binding.value.grade || binding.value.grade === 0) {
            // if(binding.value.grade || binding.value.grade === 0) {
             // funciona
            // if(binding.value.exerciseAnswers.options[0].id == binding.value.option.id) {
            // //      el.style.border = '1px solid #92e670'
            //         el.style.backgroundColor = '#ededed'
            //         el.style.color = 'green'
            // }

            //funciona
                if(binding.value.option.id === binding.value.answer && binding.value.exerciseAnswers.options[0].id === binding.value.answer) {
                     console.log('sdfsf');
                    
                    el.style.border = '1px solid #92e670'
                    el.style.backgroundColor = '#ededed'
                    el.style.color = 'green'
                }

                else if(binding.value.option.id === binding.value.answer && binding.value.exerciseAnswers.options[0].id !== binding.value.answer) {
                    console.log('aaaaaaaaaa');
                    el.style.border = '1px solid #f05959'
                    el.style.backgroundColor = '#ededed'
                    el.style.color = '#f05959'
                }

            } 
        },
        
        
  };
  